// extracted by mini-css-extract-plugin
module.exports = {"box":"style_box__30wtQ","item":"style_item__210Re"};